import { meQuery } from "@auth/me.query"
import { createFileRoute, getRouteApi } from "@tanstack/react-router"
import type { ReactElement } from "react"

import { IllustratedState } from "../../../components/IllustratedState"
import { Bots } from "./-Bots"
import { botsQuery } from "./-bots.query"
import { Builder } from "./-Builder"
import { ErrorState } from "./-Error"

const Loading = () => {
  return (
    <IllustratedState
      title="The agent beaver is rounding up your agents"
      description="Fetching the virtual agents in your solution"
    >
      <Builder />
    </IllustratedState>
  )
}

const NoVirtualAgent = () => {
  return (
    <IllustratedState
      title="Virtual Agent is not on this account"
      description="The solution you are signed in to has no Virtual Agent solution linked."
    >
      <Builder />
    </IllustratedState>
  )
}

const route = getRouteApi("/_chrome/ai-agents/")

const RouteComponent = (): ReactElement => {
  const { hasVa } = route.useLoaderData()

  return hasVa ? <Bots /> : <NoVirtualAgent />
}

export const Route = createFileRoute("/_chrome/ai-agents/")({
  loader: async ({ context }) => {
    const me = await context.queryClient.query(meQuery)
    const hasVa = me.vaSolutionUid !== null
    if (hasVa) {
      void context.queryClient.query(botsQuery)
    }
    return { hasVa }
  },
  component: RouteComponent,
  errorComponent: ErrorState,
  pendingComponent: Loading,
})
